export var PARENT_BODY = {
    height: '100%',
    margin: 0,
    overflow: 'hidden',
};
export var FULLSCREEN_BODY_ACTIVE_CLASSNAME = 'conversional-tool-fullscreen-active';
export var FULLSCREEN_BODY_ACTIVE_STYLES = ".".concat(FULLSCREEN_BODY_ACTIVE_CLASSNAME, "{margin: 0 !important;overflow: hidden !important;}");
